import { CardMetric, CardType, DataCardLegendProps } from '../../../../models/internal_api/cardInterfaces.model';
import { Metric, Metrics } from '../../../../models/internal_api/metricInterfaces.model';
import './DataCardLegend.scss';

export default function DataCardLegend(props: DataCardLegendProps) {
    const upArrowSvg = () => (
        (<svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.278526 7.88517C0.595847 8.13571 1.05784 8.08268 1.30933 7.76517L3.08635 5.52422L5.72184 2.58062V17.2691C5.72184 17.673 6.05042 18 6.45543 18C6.86045 18 7.18903 17.673 7.18903 17.2691L7.18937 2.76511L11.6175 7.87221C11.8816 8.17714 12.3453 8.21182 12.6521 7.94768C12.9588 7.68353 12.9926 7.22189 12.7275 6.91658L6.95049 0.253266C6.81264 0.0938328 6.61236 0.00170573 6.40115 0H6.39535C6.18585 0 5.98692 0.0887243 5.84805 0.244085L1.96374 4.58456L0.15876 6.85849C-0.0933902 7.17532 -0.0391357 7.63496 0.278526 7.88517Z" fill={`rgba(${props.color},1`} />
        </svg>)
    );

    const downArrowSvg = () => (
        <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6277 10.1148C12.3103 9.86429 11.8483 9.91732 11.5969 10.2348L9.81984 12.4758L7.18435 15.4194L7.18435 0.730888C7.18435 0.32703 6.85577 -5.28945e-07 6.45076 -5.64352e-07C6.04575 -5.99759e-07 5.71716 0.32703 5.71716 0.730888L5.71682 15.2349L1.28867 10.1278C1.02458 9.82285 0.56088 9.78818 0.254112 10.0523C-0.0526317 10.3165 -0.0864089 10.7781 0.178705 11.0834L5.9557 17.7467C6.09354 17.9062 6.29383 17.9983 6.50504 18L6.51084 18C6.72034 18 6.91927 17.9113 7.05814 17.7559L10.9425 13.4154L12.7474 11.1415C12.9996 10.8247 12.9453 10.365 12.6277 10.1148Z" fill={`rgba(${props.color},1`} />
        </svg>
    );

    const upLowMetrics = () => {
        return props.metrics.map((metric: CardMetric) => {
            return (<div id={`DataCardMetric-${metric.name}`} className='DataCard__legend--metric' key={metric.name}>
                {metric.name.includes('high') ? upArrowSvg() : downArrowSvg()}
                <span><b>{metric.value}</b> {metric.name}</span>
            </div>);
        });
    };

    const multipleMetrics = () => {
        return props.metrics.map((metric: CardMetric) => {
            const metricColor: string = Metrics.filter((metricElement: Metric) => metricElement.name === metric.name)[0].color;
            const styles: any = { backgroundColor: `rgba(${metricColor}, 1)` };

            return (
                <div id={`DataCardMetric-${metric.name}`} className='DataCard__legend--metric' key={'DataCard__legend--metric' + metric.name}>
                    <div className='DataCard__legend--circle' style={styles}></div>
                    <span>{metric.name}</span>
                </div>
            )
        })
    }

    const legend = () => {
        if (props.type === CardType.UP_LOW) {
            return (
                <div className='DataCard__legend--upLow'>
                    {upLowMetrics()}
                </div>
            );
        }
        else if (props.type === CardType.MULTIPLE) {
            return (
                <div className='DataCard__legend--multiple'>
                    {multipleMetrics()}
                </div>
            );
        }
        else {
            return (
                <div className='DataCard__legend--none'></div>
            );
        }
    };

    return (
        <div className='DataCard__legend'>
            {legend()}
        </div>
    );
}
